// Keep credentials in a POST body, never a proxy URL or access-log query.
const nativeFetch = self.fetch.bind(self);
self.fetch = (input, init) => {
    const value = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
    let url;
    try { url = new URL(value); } catch (_) { return nativeFetch(input, init); }
    const method = (init?.method || input.method || 'GET').toUpperCase();
    if (method === 'GET' && url.protocol === 'https:' && url.hostname === 'torrentio.strem.fun' &&
        /\/(?:manifest\.json|(?:stream|meta|catalog)\/[^?#]+\.json)$/.test(url.pathname)) {
        return nativeFetch('/api/addon-proxy', {
            method:'POST', headers:{'Content-Type':'application/json'},
            body:JSON.stringify({url:url.href}), cache:'no-store',
            signal:init?.signal || input.signal,
        }).then(response => response.ok ? response : nativeFetch(input, init));
    }
    return nativeFetch(input, init);
};
require('@stremio/stremio-core-web/worker');
